import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Properties } from "@/components/Properties";
import { ReactionModal } from "@/components/ReactionModal";
import { Footer } from "@/components/Footer";
import { properties } from "@/data/properties";

function App() {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Properties properties={properties} onReact={setSelected} />
      </main>
      <Footer />
      <ReactionModal
        property={selected}
        open={!!selected}
        onClose={() => setSelected(null)}
      />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
